// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class IieAdvocates {
    public static readonly FORCANDIDATE: string = 'For Candidate';
    public static readonly AGAINSTCANDIDATE: string = 'Against Candidate';
    public static readonly FORBALLOT: string = 'For Ballot';
    public static readonly AGAINSTBALLOT: string = 'Against Ballot';
}
